import styles from "./AuthForm.module.scss";
import Logo from "./assets/logoWithText.svg";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, PATHNAMES, ValidateInput } from "@/shared";
import { useAppDispatch, useAppSelector } from "@/shared/hooks";
import { login, logout } from "@/app/model/applicationSlice";
import { IApiError, LoginData } from "@/app/model/types";
import { useEffect } from "react";
import { getUser } from "@/entities/viewer/slice";
import $api from "@/shared/http";

const { nomenclaturePath, usersPath, ordersPath } = PATHNAMES;

export const AuthForm = () => {
  const methods = useForm<LoginData>({ mode: "onChange" });

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { isAuth, isLoading, error, showAuthModal } = useAppSelector(
    (state) => state.app,
  );

  const isOrdersAuthFlow =
    showAuthModal || location.pathname.includes(ordersPath);

  const apiError = error as IApiError;
  const isValid = methods.formState.isValid;

  const onSubmit = async (data: LoginData) => {
    await dispatch(login(data));
  };

  const fetchUser = async () => {
    const response = await $api.get("/user/info");
    if (response.data.data.roleName === "Marketer") {
      navigate(usersPath);
    } else {
      navigate(nomenclaturePath);
    }
  };

  useEffect(() => {
    if (isAuth && !showAuthModal) {
      dispatch(logout());
    }
  }, []);

  useEffect(() => {
    if (isAuth) {
      dispatch(getUser());
      methods.reset();
      if (!isOrdersAuthFlow) {
        fetchUser();
      }
    }
  }, [isAuth, isOrdersAuthFlow]);

  return (
    <div className={styles.signinMain}>
      <div className={styles.signinLogo}>
        <Logo fill="url(#pattern0)" width={160} height={68} />
      </div>

      <div className={styles.signinTitle}>
        <h1>Добро пожаловать!</h1>
        <span>Войдите в SKAD online</span>
      </div>
      <FormProvider {...methods}>
        <form
          className={styles.signinForm}
          onSubmit={methods.handleSubmit(onSubmit)}
        >
          <div className={styles.inputBlock}>
            <ValidateInput
              placeholder="Введите свой логин"
              name="email"
              nameRu="Логин"
              required
              pattern={/^\S+@\S+$/i}
              externalError={apiError?.detail && " "}
            />
          </div>

          <div className={styles.inputBlock}>
            <ValidateInput
              placeholder="Введите свой пароль"
              name="password"
              nameRu="Пароль"
              type="password"
              externalError={apiError?.detail as string}
              required
            />
          </div>
          <div className={styles.signinSubmitBtn}>
            <Button
              type="submit"
              name="Войти"
              disabled={!isValid || isLoading}
              buttontStyle="default"
              isLoading={isLoading}
            />
          </div>
        </form>
      </FormProvider>
    </div>
  );
};
